import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { GrupoFiltroDTO, IGrupoFiltroDTO } from "@DTOS";
import { Constants } from "@constants";
import { map } from "rxjs/operators";
import { firstValueFrom } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class GruposFiltrosServiceBackend {
    constructor(private httpClient: HttpClient) {}

    public async getGruposFiltros(): Promise<GrupoFiltroDTO[]> {
        return await firstValueFrom(
            this.httpClient.get<IGrupoFiltroDTO[]>(
                `${Constants.apiURL}/signon-triggers`
            ).pipe(
                map(response => response.map(grupoFiltro => new GrupoFiltroDTO(grupoFiltro)))
            )
        ) ?? [];
    }

    public async postGruposFiltros(grupoFiltro: GrupoFiltroDTO): Promise<GrupoFiltroDTO> {
        const response = await firstValueFrom(
            this.httpClient.post<IGrupoFiltroDTO>(
                `${Constants.apiURL}/signon-triggers`, grupoFiltro.obtenerJSON()
            )
        );

        return new GrupoFiltroDTO(response);
    }

    public async putGruposFiltros(grupoFiltro: GrupoFiltroDTO): Promise<GrupoFiltroDTO> {
        const response = await firstValueFrom(
            this.httpClient.put<IGrupoFiltroDTO>(
                `${Constants.apiURL}/signon-triggers/${grupoFiltro.id}`, grupoFiltro.obtenerJSON()
            )
        );

        return new GrupoFiltroDTO(response);
    }

    public async deleteGruposFiltros(grupoFiltro: GrupoFiltroDTO): Promise<void> {
        await firstValueFrom(
            this.httpClient.delete<IGrupoFiltroDTO>(
                `${Constants.apiURL}/signon-triggers/${grupoFiltro.id}`
            )
        );
    }
}
